<template>
  <wrap-container>
    <help-title title="Adquisición de un nuevo producto" />

    <help-list-container>
      <help-list-item
        tituloLista="Requisitos para la apertura de una Caja de Seguridad:"
      >
        - Ser Cliente del Banco.<br />
        - Poseer una cuenta monetaria en donde realizar el débito.
      </help-list-item>

      <help-list-item
        tituloLista="Disponiblidad y costos de las cajas de seguridad:"
      >
        Para consultar sobre la disponibilidad y costos de las cajas de
        seguridad:<br />
        - Deberás tomar contacto con un oficial de cuentas de la sucursal en la
        que decidas realizar la apertura de dicho producto.<br />
        Te recordamos que la ubicación de Sucursales la encontrarás ingresando a
        nuestra página de
        <a id="contactForm" href="https://www.bbva.com.ar">Banca Online</a
        >:<br />
        - En el borde superior central, bajo el icono llamado
        <strong>"Sucursales y Cajeros"</strong>.<br />
        Allí podrás ubicar los teléfonos y dirección de la Sucursal que
        necesites.
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
